// extracted by mini-css-extract-plugin
export default {"l_MoveArrowBtn_main":"MoveArrowBtn_l_MoveArrowBtn_main__Mmzdo","diraction":"MoveArrowBtn_diraction__EYnUe","left":"MoveArrowBtn_left__BlG0-","right":"MoveArrowBtn_right__O4VlN"};